import React from 'react';
import './Styles.css';
import '@ids/style-loader';

const LoaderComponent = () => {
  return (
    <div role="alert" aria-live="assertive" aria-label="Loading" className="loader-container">
      <span className="if loader spinner"></span>
    </div>
  );
};

export default LoaderComponent;
